import React, { useMemo } from "react";
import styled, { keyframes } from "styled-components";

const fly = keyframes`
  0% {
    transform: translate(-50%, -50%) scale(0.2);
    opacity: 0;
  }
  25% {
    opacity: 1;
  }
  100% {
    transform: translate(
        calc(-50% + var(--dx)),
        calc(-50% + var(--dy))
      )
      rotate(var(--rot));
    opacity: 0;
  }
`;

const Piece = styled.span<{ $delay: number; $color: string }>`
  position: absolute;
  left: 50%;
  top: 50%;
  width: 8px;
  height: 8px;
  border-radius: 2px;
  background: ${({ $color }) => $color};
  animation: ${fly} 1s ease-out forwards;
  animation-delay: ${({ $delay }) => $delay}ms;
  pointer-events: none;
`;

/** Origin at horizontal + vertical centre of the banner */
const Wrap = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  overflow: visible;
  pointer-events: none;
  z-index: 2;
`;

const COLORS = ["#0FA457", "#451999", "#FFB020", "#E91E8C", "#1b73e8"];

const ConfettiBurst = () => {
  const pieces = useMemo(
    () =>
      Array.from({ length: 16 }, (_, i) => ({
        id: i,
        delay: i * 25,
        color: COLORS[i % COLORS.length],
        dx: `${(Math.random() - 0.5) * 100}px`,
        dy: `${-30 - Math.random() * 80}px`,
        rot: `${Math.random() * 540}deg`
      })),
    []
  );

  return (
    <Wrap aria-hidden>
      {pieces.map((p) => (
        <Piece
          key={p.id}
          $delay={p.delay}
          $color={p.color}
          style={
            {
              "--dx": p.dx,
              "--dy": p.dy,
              "--rot": p.rot
            } as React.CSSProperties
          }
        />
      ))}
    </Wrap>
  );
};

export default ConfettiBurst;
